'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daynamicModel = _angular2.default.module('dynamicModel', []).directive('dynamicModel', function ($parse, $compile) {
  'ngInject';

  return {
    restrict: 'A',
    terminal: true,
    priority: 100000,
    link: function link(scope, elem, attrs, ctrl) {
      var name = $parse(elem.attr('dynamic-model'))(scope);
      elem.removeAttr('dynamic-model');
      elem.attr('ng-model', name);
      $compile(elem)(scope);
    }
  };
}).name;

exports.default = daynamicModel;


// WEBPACK FOOTER //
// ./client/app/common/directive/dynamicModel/dynamicModel.js